import { ErrorBoundary, Suspense } from "@suspensive/react";
import { SuspenseQuery } from "@suspensive/react-query";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { SubscriptionAnalyticsKpiCards } from "./subscription-analytics-kpi-cards";
import { SubscriptionPlanCards } from "./subscription-plan-cards";
import { SubscriptionPlanDistributionChart } from "./subscription-plan-distribution-chart";
import { SubscriberTrendChart } from "./subscriber-trend-chart";
import { subscriptionAnalyticsQueryOptions } from "@/hooks/use-subscriptions";
import { StatsLoadingFallback } from "@/components/suspense/loading-fallback";
import { SectionErrorFallback } from "@/components/error-boundary/error-fallback";

export function SubscriptionAnalyticsTab() {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset} fallback={SectionErrorFallback}>
          <Suspense fallback={<StatsLoadingFallback />}>
            <SuspenseQuery {...subscriptionAnalyticsQueryOptions()}>
              {({ data }) => (
                <div className="space-y-6">
                  <SubscriptionAnalyticsKpiCards analytics={data} />
                  <SubscriberTrendChart />
                  <SubscriptionPlanCards breakdown={data.breakdown} />
                  <SubscriptionPlanDistributionChart
                    breakdown={data.breakdown}
                  />
                </div>
              )}
            </SuspenseQuery>
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
